import { RouteObject } from 'react-router'
import announcementsRoutes from './announcements/routes'
import awardsRoutes from './awards/routes'
import celebrationsRoutes from './celebrations/routes'
import checkInsRoutes from './checkIns/routes'
import incentivesRoutes from './incentives/routes'
import spacesRoutes from './spaces/routes'

const routes: RouteObject[] = [
  ...announcementsRoutes,
  ...awardsRoutes,
  ...celebrationsRoutes,
  ...checkInsRoutes,
  ...incentivesRoutes,
  ...spacesRoutes,
]

export default routes
